import { Store } from "pullstate";

export const NotificationStore = new Store({
    notifications: [],
    currentNotification: {},
    openModal: false,
    cursor: new Date().toISOString()
});